module.exports = "query {\n    getCountriesList {\n        id\n        name\n        countryCode\n        phoneCode\n    }\n}\n"